import {
    EnumWorkflowStepOutcome,
    getBadgeVariantByWorkflowStepOutcome,
    getEnumWorkflowStepOutcomeLabel,
    type ApiWorkflowRunStep,
} from '@Model';
import { Badge, Column } from '@synqo/frontend-component-library';

export const workflowRunStepColumns: Column<ApiWorkflowRunStep>[] = [
    { name: 'action_kind', label: 'Kind' },
    { name: 'action_id', label: 'Aktion' },
    {
        name: 'outcome',
        label: 'Ergebnis',
        renderCell: ({ cellData }) => {
            const outcome = cellData as EnumWorkflowStepOutcome;
            return (
                <Badge variant={getBadgeVariantByWorkflowStepOutcome(outcome)}>
                    {getEnumWorkflowStepOutcomeLabel(outcome)}
                </Badge>
            );
        },
    },
    { name: 'started_at', label: 'Start', type: 'datetime' },
    { name: 'finished_at', label: 'Ende', type: 'datetime' },
    { name: 'command_id', label: 'Command-ID' },
];
